__turbopack_context__.v({
  "container": "Container-module__bX3luW__container",
  "section": "Container-module__bX3luW__section",
  "tight": "Container-module__bX3luW__tight",
});
